import {
  type EditPreSeasonAggregationResponse,
  type GetPreSeasonAggregationsListResponse,
  type PreSeasonAggregationListItem,
} from '../types';

import { mapRowDimensionToIdentifier } from './map-row-dimension-to-identifier';
import { getDimensions } from './transform-dimensions';

export const transformEditPreSeasonAggregationResponse = ({
  items,
}: EditPreSeasonAggregationResponse) => {
  return {
    items: items.map(transformPreSeasonAggregationItem),
  };
};

export const transformPreSeasonAggregationResponse = ({
  page_info,
  items,
}: GetPreSeasonAggregationsListResponse) => {
  return {
    page_info,
    items: items.map(transformPreSeasonAggregationItem),
  };
};

const transformPreSeasonAggregationItem = (
  item: PreSeasonAggregationListItem,
) => {
  const rowIdentifiers = item.dimensions.map((dimension) =>
    mapRowDimensionToIdentifier(dimension),
  );

  const rowIdentifiersString = JSON.stringify(rowIdentifiers);
  return {
    id: rowIdentifiersString,
    is_fetching_initial_allocation_recommendations: false,
    is_fetching_remaining_wh_stock: false,
    is_fetching_assortment_dates: false,
    is_fetching_assortment_status: false,
    is_fetching_coverage_period: false,
    is_fetching_min_ia: false,
    is_fetching_target_coverage: false,
    requests_in_flight: 0,
    ...item,
    dimensions: getDimensions(item.dimensions),
  };
};
